import React, { Component } from 'react';
import { Card } from 'react-bootstrap';

class ClientesPacsConsumoInfo extends Component {
  render() {
    const { pacs = [] } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-black card-label-info">Finkok: </strong>
          {pacs['finkok']}
          <br />

          <strong className="text-black card-label-info">Timbox: </strong>
          {pacs['timbox']}
          <br />

          <strong className="text-black card-label-info">Turbo Pac: </strong>
          {pacs['turbopac']}
          <br />

          <strong className="text-black card-label-info">Smart Web: </strong>
          {pacs['sw']}
          <hr />

          <strong className="text-black card-label-info">Total: </strong>
          {pacs['finkok'] + pacs['timbox'] + pacs['turbopac'] + pacs['sw']}
          <br />
        </Card.Body>
      </Card>
    );
  }
}

export default ClientesPacsConsumoInfo;
